<button class="slds-button {{class}}" aria-haspopup="true" aria-expanded="true" (click)="clickBtn()">
  <ng-content></ng-content>
</button>